import { ImgBaseUrl } from '../setting';

const lang = localStorage.getItem('lang') || 'zh';

export const getLangImg = (obj, key) => {
	let url = obj[key];
	if (lang === 'en') {
		url = obj[`${key}En`];
	}

	if (/^http(s)?/.test(url)) {
		return url;
	}

	return ImgBaseUrl + url;
};

export function addPrefixToImgSrc(html, prefix = ImgBaseUrl) {
	// 定义正则表达式
	const regex = /<img\s+([^>]*?src=['"]([^'"]+)['"])([^>]*?)>/g;
	return html.replace(regex, function (match, group1, src, group3) {
		if (!src.match(/^https?:\/\//i)) {
			// 为src添加前缀
			const newSrc = prefix + src;
			// 构建新的img标签
			return (
				'<img ' +
				group1
					.replace(`src="${src}"`, `src="${newSrc}"`)
					.replace(`src='${src}'`, `src='${newSrc}'`) +
				group3 +
				'>'
			);
		}
		return match;
	});
}
